var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L11.2929 15.2929L10.5858 16L11.2929 16.7071L12 16ZM19.2929 7.29289L11.2929 15.2929L12.7071 16.7071L20.7071 8.70711L19.2929 7.29289ZM11.2929 16.7071L19.2929 24.7071L20.7071 23.2929L12.7071 15.2929L11.2929 16.7071Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAngleLeft);
export default __webpack_public_path__ + "static/media/icon-angle-left.8519ba5a8bebcde81fef64e69cacdb08.svg";
export { ForwardRef as ReactComponent };